import axios from 'axios'
import { Filter } from '../../../components/_WMS/FilterComponent'
import { ApiConfig } from '../../../config/api'
import { GenericOrderBy } from '../../../components/_EOS/Table'
import { Warehouse } from '../../../interfaces/Warehouse/Warehouse'

export const getWarehouseList = (
  filters: Filter[],
  page: number,
  pageSize: number,
  orderBy?: GenericOrderBy<Warehouse>
) => {
  const url = new URL(`${ApiConfig.WareHouseApi}`)

  url.searchParams.set('pageIndex', page.toString())
  url.searchParams.set('pageSize', pageSize.toString())

  if (filters) {
    filters.forEach((element) => {
      url.searchParams.append(element.key, element.value.toString())
    })
  }

  if (orderBy) {
    url.searchParams.set(
      'sorters',
      JSON.stringify({ datafield: orderBy.field, sortOrder: orderBy.direction })
    )
  }

  return axios.get(url.toString())
}

export const getWarehouseById = (id: number) => {
  return axios.get(`${ApiConfig.WareHouseApi}/${id}`)
}

export const createWarehouse = (warehouse: Warehouse) => {
  return axios.post(`${ApiConfig.WareHouseApi}`, warehouse)
}

export const updateWarehouse = (id: number, warehouse: Warehouse) => {
  return axios.put(`${ApiConfig.WareHouseApi}/${id}`, warehouse)
}

export const deleteWarehouse = (id: number) => {
  return axios.delete(`${ApiConfig.WareHouseApi}/${id}`)
}

// Obtiene todas las bodegas con sus zonas 
export const getWarehouseWhitZone = () => {
  return axios.get(`${ApiConfig.WareHouseApi}/WithZones`)
}
